import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { baseInputClasses, BaseInput, ModalContent } from "@kaltura/ds-react-components";

export const StyledModalContent = styled(ModalContent)(({ theme }) => ({
    paddingBottom: theme.spacing(5),
}));

export const StyledContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(4),
}));

export const StyledFormContainer = styled(Box)(({ theme }) => ({
    minWidth: 343,
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        minWidth: "100%",
    },
}));

export const StyledPlayerContainer = styled(Box)(({ theme }) => ({
    position: "relative",
    width: "100%",
    overflow: "hidden",
    borderRadius: 10,
    paddingBottom: "40%",
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        display: "none",
    },
}));

export const Spacer = styled(Box)(({ theme }) => ({
    height: theme.spacing(3),
}));

export const StyledActions = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "flex-end",
    alignItem: "center",
    padding: theme.spacing(2, 5),
    borderTop: `1px solid ${theme.kaltura.palette.tone4}`,
}));

export const StyledInput = styled(BaseInput)(({ theme }) => ({
    [`&.${baseInputClasses.readOnly}`]: {
        borderColor: theme.kaltura.palette.tone4,
    },
}));
